// @flow
import * as React from 'react';
import classNames from 'classnames';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import isEqual from 'react-fast-compare';
import styles from './ModalHeader.module.scss';

type Props = {
    backButton?: boolean,
    className: string,
    closeButton: boolean,
    content: React.Node,
    contentClassName: string,
    hideLogo: boolean,
    logoClassName: string,
    onBack?: Function,
    onHide: Function,
};

export default class ModalHeader extends React.Component<Props> {
    static defaultProps = {
        backButton: false,
        className: '',
        closeButton: true,
        content: '',
        contentClassName: '',
        hideLogo: false,
        logoClassName: '',
    };

    shouldComponentUpdate = (nextProps: Props) => !isEqual(this.props, nextProps);

    render() {
        const {
            backButton,
            className,
            closeButton,
            content,
            contentClassName,
            hideLogo,
            logoClassName,
            onBack,
            onHide,
        } = this.props;

        const headerClass = classNames(className, styles.header);
        const logoClass = classNames(logoClassName, styles.logo);
        const contentClass = classNames(contentClassName, styles.content);

        return (
            <div className={headerClass}>
                {backButton && (
                    <button className={styles['back-button']} onClick={onBack} type="submit">
                        <FontAwesomeIcon icon={faChevronLeft} />
                    </button>
                )}
                {closeButton && (
                    <button className={styles['close-button']} onClick={onHide} type="submit">
                        <span>×</span>
                    </button>
                )}
                {!hideLogo && (
                    <img className={logoClass} src="https://p1.liveauctioneers.com/dist/images/logo.svg" alt="logo" />
                )}
                {content && <span className={contentClass}>{content}</span>}
            </div>
        );
    }
}
